import React from 'react'
import { css } from 'aphrodite'
import ReactSelect, { components as rsComponents } from 'react-select'

import style from '../style'

const Selector = props => {
  const options = [
    { value: '-1', label: 'All' },
    ...props.options.map(o => ({ value: o.id, label: o.name }))
  ]

  return (
    <ReactSelect
      onChange={props.onChange}
      value={options.find(o => o.value === props.value)}
      placeholder={`All`}
      options={options}
      theme={theme => ({
        ...theme,
        borderRadius: 0,
        outline: `inherit`,
        spacing: {
          ...theme.spacing,
          controlHeight: 40
        },
        colors: {
          ...theme.colors,
          primary: `#ddd`,
          primary25: '#f5f5f5',
          neutral0: `white`,
          neutral5: `#ddd`,
          neutral20: `#ddd`,
          neutral30: `#ddd`,
          neutral40: `black`,
          neutral50: `black`
        }
      })}
      styles={{
        fontSize: `14px`
      }}
    />
  )
}

export default Selector



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/CommunitySelector.js